export default {
  admin: [

  ],
}